import React from 'react'
import { BeWizrCourseItem } from '~/models'
import { memo } from '~/ui/component'
import { List } from '~/ui/components'
import { layout } from '~/ui/styling'
import BeWizrCourseListItem from './BeWizrCourseListItem'

export interface Props {
  items:              BeWizrCourseItem[]
  expandedItemIndex?: number
  interactive?:       boolean
  showStatus?:        boolean
}

const BeWizrCourseItemList = memo('BeWizrCourseItemList', (props: Props) => {

  const {items, expandedItemIndex, showStatus = true, interactive = true} = props

  //------
  // Rendering

  function render() {
    return (
      <List
        flex={false}
        data={items}
        renderItem={renderItem}
        itemGap={layout.padding.inline.m}
      />
    )
  }

  function renderItem(item: BeWizrCourseItem, index: number) {
    return (
      <BeWizrCourseListItem
        item={item}
        expanded={index === expandedItemIndex}
        interactive={interactive}
        showStatus={showStatus}
      />
    )
  }

  return render()

})

export default BeWizrCourseItemList